import React from "react";
import { Route, Routes } from "react-router-dom";
import NoticeListComponent from "../components/board/NoticeListComponent";
import NoticeDetailComponent from "../components/board/NoticeDetailComponent";

export default function NoticeBoardPage() {
    return (
        <Routes>
            <Route path="/*" element={<NoticeListComponent />} />
            <Route path="/:id/*" element={<NoticeDetailComponent />} />
        </Routes>
    );
}
